// src/pages/DoctorsOverview/DoctorsThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createClinic,
  createDoctor,
  getLocationApi,
  getClinic,
} from "../../apiservice/setting";
import {
  getDoctorClinicDetailsApi,
  getClinicDetailsApi,
  deleteDoctor,
  deleteClinic,
} from "../../apiservice/pharma";

// Clinics list
export const fetchClinicsList = createAsyncThunk(
  "doctors/fetchClinicsList",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getClinic({});
      return res.data || [];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Clinics details (for clinic table summary)
export const fetchClinicsDetails = createAsyncThunk(
  "doctors/fetchClinicsDetails",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getClinicDetailsApi(null);
 
      return res.data || [];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Doctors list
export const fetchDoctorsList = createAsyncThunk(
  "doctors/fetchDoctorsList",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getDoctorClinicDetailsApi(null);
      return res.data || [];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// create/update clinic
export const createOrUpdateClinic = createAsyncThunk(
  "doctors/createOrUpdateClinic",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await createClinic(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// create/update doctor
export const createOrUpdateDoctor = createAsyncThunk(
  "doctors/createOrUpdateDoctor",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await createDoctor(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// delete clinic
export const removeClinic = createAsyncThunk(
  "doctors/removeClinic",
  async (id, { rejectWithValue }) => {
    try {
      const res = await deleteClinic({ id });
      if (res.data.error) {
        return rejectWithValue(res.data.message);
      }
      return res.data;
    } catch (err) {      
      console.log("err.message:", err.message);
      console.log("API Error:", err.response?.data);
       return rejectWithValue(
        err.message || err.response?.data?.message || "Delete failed"
      );
    }
  }
);

// delete doctor
export const removeDoctor = createAsyncThunk(
  "doctors/removeDoctor",
  async (id, { rejectWithValue }) => {
    try {
      const res = await deleteDoctor({ id });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// locations lookup
export const fetchLocations = createAsyncThunk(
  "doctors/fetchLocations",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getLocationApi(null);
      return res.data || [];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
